import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib/analytics";
import { isDefined } from "@clipboard-health/util-ts";
import { type UseQueryResult } from "@tanstack/react-query";

import { focusModeStatusResponseSchema, type FocusModeStatusResponse } from "./types";

interface GetFocusModeStatusParams {
  shiftId?: string;
}

export function useGetFocusModeStatus(
  params: GetFocusModeStatusParams,
  options: UseGetQueryOptions<FocusModeStatusResponse> = {}
): UseQueryResult<FocusModeStatusResponse> {
  const { shiftId } = params;

  return useGetQuery({
    url: `${environmentConfig.REACT_APP_BASE_API_URL}/shifts/${shiftId}/focus-mode/status`,
    responseSchema: focusModeStatusResponseSchema,
    enabled: isDefined(shiftId),
    meta: {
      logErrorMessage: APP_V2_USER_EVENTS.FOCUS_MODE_FAILED,
    },
    ...options,
  });
}
